import React, { useState } from "react";
import {
  Container,
  Header,
  Title,
  Pagination,
  PageButton,
} from "../UserPaymentsDashboard/UserPaymentsDashboard.styles";
import Logo from "../../sharable/Logo";
import { useOutletContext } from "react-router-dom";
import { useAllPaymentsPaginated } from "./useAllPaymentsPaginated";
import Notification from "../../sharable/Notification";
import PaymentsTable from "../../sharable/PaymentsTable";
import UpdatePaymentModal from "../UserPaymentsDashboard/PaymentModal/UpdatePaymentModal";

export default function AllPaymentsDashboard({ onClose }) {
  const { user, token } = useOutletContext();
  const [page, setPage] = useState(0);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [refreshCount, setRefreshCount] = useState(0);
  const size = 10;
  const { payments, loading, error, totalPages } = useAllPaymentsPaginated(
    token,
    page,
    size,
    refreshCount,
  );

  const handleRefresh = () => {
    setRefreshCount((count) => count + 1);
  };

  if (!user || user.authority !== "ADMIN") {
    return (
      <Container>
        <Header>
          <Logo showGoBackButton={true} path="/encartes" />
        </Header>
        <Title>Administração</Title>
        <div>Você não tem permissão para acessar este painel.</div>
      </Container>
    );
  }

  return (
    <Container>
      <Header>
        <Logo showGoBackButton={true} path="/user-dashboard" />
      </Header>
      <Title>Todos os Pagamentos</Title>
      {error && <Notification message={error} type="error" />}
      <PaymentsTable
        payments={payments}
        loading={loading}
        showAction={true}
        onAction={(payment) => {
          setSelectedPayment(payment);
        }}
      />

      {totalPages > 1 && (
        <Pagination>
          <PageButton
            onClick={() => setPage((p) => Math.max(0, p - 1))}
            disabled={page === 0}
          >
            Anterior
          </PageButton>
          <span>
            Página {page + 1} de {totalPages}
          </span>
          <PageButton
            onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
            disabled={page === totalPages - 1}
          >
            Próxima
          </PageButton>
        </Pagination>
      )}
      {onClose && (
        <PageButton style={{ marginTop: 16 }} onClick={onClose}>
          Fechar
        </PageButton>
      )}
      {selectedPayment && (
        <UpdatePaymentModal
          key={selectedPayment.id}
          payment={selectedPayment}
          onClose={() => {
            setSelectedPayment(null);
            handleRefresh();
          }}
        />
      )}
    </Container>
  );
}
